import { UserContext } from "../../contexts/UserContext";
import { AutosizeTextarea } from "../ui/autoresizeTextArea";
import { Button } from "../ui/button";
import { Card, CardHeader, CardContent, CardTitle } from "../ui/card";
import {
    Form,
    FormControl,
    FormDescription,
    FormField,
    FormItem,
    FormLabel,
    FormMessage,
} from "../ui/form";
import { Input } from "../ui/input";

import {
    WithLoggedInAuthInfoProps,
    withRequiredAuthInfo,
} from "@propelauth/react";
import React, { useContext } from "react";
import { SubmitHandler, useForm } from "react-hook-form";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useToast } from "../ui/use-toast";

import { createQAItem, getQaItem, updateQAItem } from "./qa_api";
import { QAModel } from "./QAModel";

type CreateQAProps = WithLoggedInAuthInfoProps & {
    editable?: boolean;
    create?: boolean;
    qaItem?: QAModel;
    qa_id?: string;
    parent_id?: string;
    onSave?: (data: QAModel) => void;
    onCancel: () => void;
};

function blankQAitem() {
    return {
        title: "",
        body: "",
    };
}

const QAItemForm: React.FC<CreateQAProps> = (props) => {
    const { project_id } = useParams<string>();

    const userContext = useContext(UserContext);
    const { toast } = useToast();
    const [isEditing, setIsEditing] = React.useState<boolean>(true);

    const form = useForm<QAModel>({
        defaultValues: blankQAitem(),
        mode: "onChange",
    });

    if (!project_id) {
        return <div>No ProjectID </div>;
    }

    const onSave: SubmitHandler<QAModel> = (data: QAModel) => {
        {
            console.error("creating qa:", data);

            createQAItem(project_id, props.accessToken, data)
                .then((data) => {
                    toast({
                        title: "Success!",
                        description: "Item created successfully.",
                        variant: "default",
                    });
                    if(props.onSave){
                        props.onSave(data)
                    }
                })
                .catch((error) => {
                    console.error("Error creating qa:", error);
                    toast({
                        title: "Error",
                        description: error.message || "Failed to create bid.",
                        variant: "destructive",
                    });
                });
        }
    };

    return (
        <div className="container">
            <Card>
                <Form {...form}>
                    <form
                        onSubmit={(e) => {
                            e.preventDefault();
                            form.handleSubmit(onSave)();
                        }}
                    >
                        <CardHeader>
                            <CardTitle className="columns-2 flex justify-between "></CardTitle>

                            <div>
                                {isEditing ? (
                                    <div className="items-center flex justify-between ">
                                        <Button
                                            onClick={() => props.onCancel()}
                                            type="button"
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            variant={"secondary"}
                                            type="submit"
                                            disabled={!form.formState.isValid}
                                        >
                                            Save
                                        </Button>
                                    </div>
                                ) : (
                                    <div>
                                        <Button
                                            type="button"
                                            onClick={() => setIsEditing(true)}
                                        >
                                            Edit
                                        </Button>
                                    </div>
                                )}
                            </div>
                        </CardHeader>
                        <CardContent>
                            <div className="">
                                <div className="">
                                    {props.parent_id ? (
                                        <></>
                                    ) : (
                                        <FormField
                                            control={form.control}
                                            name="title"
                                            rules={{
                                                required: "Title is required",
                                            }}
                                            render={({ field }) => (
                                                <FormItem>
                                                    <FormLabel>Title</FormLabel>
                                                    <FormControl>
                                                        <Input
                                                            placeholder=""
                                                            {...field}
                                                            className="disabled:cursor-allowed disabled:opacity-100 disabled:border-none"
                                                            disabled={
                                                                !isEditing
                                                            }
                                                        />
                                                    </FormControl>
                                                    <FormDescription></FormDescription>
                                                    <FormMessage />{" "}
                                                </FormItem>
                                            )}
                                        />
                                    )}
                                </div>
                            </div>
                            <FormField
                                control={form.control}
                                name="body"
                                rules={{ required: "Body is required" }}
                                render={({ field }) => (
                                    <FormItem>
                                        <FormLabel>Body</FormLabel>
                                        <FormControl>
                                            <AutosizeTextarea
                                                {...field}
                                                className="disabled:cursor-allowed disabled:opacity-100 disabled:border-none"
                                                disabled={!isEditing}
                                            />
                                        </FormControl>
                                        <FormMessage />{" "}
                                    </FormItem>
                                )}
                            />
                        </CardContent>
                    </form>
                </Form>
            </Card>
        </div>
    );
};

export default withRequiredAuthInfo(QAItemForm);
